module.exports = Promise.all([__parcel__import__("6MK7E"), __parcel__import__("x0sWj")]).then(() => parcelRequire('g36Vt'));